import React, {useState} from "react";
export default function MiniSelectBox(props) {
    const [showDropDown , setShowDropDown] = useState(false)
    const [variable , setVariable] = useState(props.variable)
    const [title , setTitle] = useState(props.title)
    const [edit , setEdit] = useState(false)

    return(
            <>
                <div className="d-flex justify-content-between title-editor m-auto">
                    {edit ?
                        <input className="input-change-table" onChange={e => setTitle(e.target.value)} value={title} onBlur={() => setEdit(false)} type="text"/>
                        :
                        <p>{title}</p>
                    }
                    {
                        !props.readOnly && !edit &&
                        <svg onClick={() => setEdit(true)} width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.18268 1.74312H4.84581C2.92393 1.74312 1.71893 3.10374 1.71893 5.02999V10.2262C1.71893 12.1525 2.91831 13.5131 4.84581 13.5131H10.3608C12.2889 13.5131 13.4883 12.1525 13.4883 10.2262V7.70874" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M5.51736 6.82556L10.188 2.15493C10.7699 1.57368 11.713 1.57368 12.2949 2.15493L13.0555 2.91556C13.6374 3.49743 13.6374 4.44118 13.0555 5.02243L8.36236 9.71556C8.10799 9.96993 7.76299 10.1131 7.40299 10.1131H5.06174L5.12049 7.75056C5.12924 7.40306 5.27111 7.07181 5.51736 6.82556Z" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M9.47824 2.87656L12.332 5.73031" stroke="#0A195C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    }
                </div>
              {
                !props.readOnly &&
                  <div className="mt-2 mini-select-box d-flex justify-content-between align-items-center" onClick={() => setShowDropDown(!showDropDown)} onBlur={() => setShowDropDown(false)} tabIndex={-1}>
                    <p>{variable}</p>
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.5 1.25L5 4.75L1.5 1.25" stroke="#200E32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {
                      showDropDown &&
                      <div className="table-drop-down">
                        <p onClick={() => setVariable('integer')}>integer</p>
                        <p onClick={() => setVariable('string')}>string</p>
                        <p onClick={() => setVariable('float')}>float</p>
                        <p onClick={() => setVariable('datetime')}>datetime</p>
                      </div>
                    }

                  </div>
              }
            </>
    )
}
